<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  
  <div class="d-flex align-items-center">
    <!-- <el-button type="success" size="mini" @click="openModel(false)">添加规格</el-button> -->
  
    <div class="mr-auto">
      <el-form inline ref="form" :model="searchform">

          <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                 :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
  
  </div>

  <el-table
      :data="tableData"
       v-loading="loading"
        show-summary
       :summary-method="getSummaries"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">


       <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt1)}}</template>
      </el-table-column>
     
      <el-table-column
        
         :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt2)}}</template>
      </el-table-column>
      
      
        <el-table-column
        
        :label="$t('msg.배팅')" prop="tt5" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5)}}</template>
      </el-table-column>
        <el-table-column
        
        :label="$t('msg.당첨')" prop="tt6" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6)}}</template>
      </el-table-column>

       <el-table-column
        
       :label="$t('msg.롤링')"  prop="tt4" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt4)}}</template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.루징')" prop="tt3" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt3)}}</template>
      </el-table-column>

      <el-table-column
        
        :label="$t('msg.수익')" prop="tt7" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7)}}</template>
      </el-table-column>

  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
        
        
</div>
 </template>

 <script>
 
    export default {
      
      data(){
        return{
          domain:window.sessionStorage.getItem('domain'),
            qa:[],
             colorObj:{
              '0':'text-danger',
              '1':'text-primary',
              '2':'text-success',
             
             
            },
          
          searchform:{
            
            time:[],
          


          },
           pickerOptions: {
          },
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
       
          
            
        
          total:0,
          size:0,
          loading: false,
           editIndex:-1,
           creatModel:false,
           tableData: [],
          
                currentPage:1,
                multipleSelection:[],
             
               
          }
          
          
        },
        created() {
          

          this.getList();
          
      
    },
      
      methods:{
          getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$i18n.t("msg.총");
          } else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
      
           // 搜索事件
      searchEvent(){
this.currentPage=1;
          this.getList();
          
             

        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
           
        getList(){

         
               console.log(this.searchform.time) 
         

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/apibetlist2?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage;
          
    
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data)
                     this.tableData =response.data.data
                     this.total = response.data.total
                     this.currentPage = response.data.current_page
                     this.size =response.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
              

               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
        
        
      
      
      
        
      }
  }
</script>

 <style scoped>
 .bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }


</style>


// WEBPACK FOOTER //
// src/views/betting2/list.vue